import { type ReactElement, useEffect } from 'react'

type IRefreshWrapperProps = {
  setRefresh: (value: boolean) => void
  refresh: boolean
  children: ReactElement
}

export const RefreshWrapper = ({ setRefresh, refresh, children }: IRefreshWrapperProps) => {
  useEffect(() => {
    if (refresh) {
      setRefresh(false)
    }
  }, [refresh])

  if (refresh) {
    return null
  }
  return children
}
